










import BanManager from "@/components/Ban/BanManager.vue";
import PageTemplate from "@/components/PageTemplate.vue";
import { RouteName } from "@/router/types";
import { Vue, Component } from "vue-property-decorator";

@Component({
  components: {
    PageTemplate,
    BanManager,
  },
})
export default class Bans extends Vue {
  RouteName = RouteName;
}
